import { Input, MultiSelect, Select } from "./components";

const renderComponent = (data, setValue) => {
  switch (data.type) {
    case "input": {
      const onChange = (value) => setValue(value);
      return (
        <Input
          label={data?.label}
          name={data?.name}
          onChange={onChange}
          value={data?.default_value}
        />
      );
    }

    case "multi-select": {
      const onChange = (items) =>
        setValue(items?.length ? items.map(({ value }) => value) : null);

      return (
        <MultiSelect
          label={data.label}
          value={data?.default_value}
          options={data?.options || []}
          onChange={onChange}
        />
      );
    }

    case "select": {
      const onChange = ({ value }) => setValue(value);

      return (
        <Select
          label={data.label}
          value={data?.default_value}
          options={data?.options || []}
          onChange={onChange}
        />
      );
    }

    default:
      return null;
  }
};

const MainFilters = ({ data = [], current_filters = {}, setQueryFilters }) => (
  <div className="product-workflow-list__filters">
    <div className="filters-grid">
      {data.map((item) => {
        const setValue = (values) =>
          setQueryFilters({
            name: item.name,
            values: values,
          });

        const default_value = current_filters[item.name];
        return (
          <div key={item.name} className="form-group">
            {renderComponent({ ...item, default_value }, setValue)}
          </div>
        );
      })}
    </div>
  </div>
);

export default MainFilters;
